// Import dependencies
import { unsafeCSS, css, html, LitElement, render } from 'lit';
import { customElement, query, property } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
const { isEmpty, htmlEntities } = _uo.utility;

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.itemLoop;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop-filter-btn-edit' )
export class AutomatorBuilderItemLoopFilterEdit extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The unique ID of the loop (parent of this loop filter)
	@property( { type: Number, attribute: 'loop-id' } ) accessor loopID;

	// The unique ID of this loop filter
	@property( { type: Number, attribute: 'loop-filter-id' } ) accessor loopFilterID;

	// The code of the loop filter
	@property( { type: String, attribute: 'loop-filter-code' } ) accessor loopFilterCode;

	// The code of the integration
	@property( { type: String, attribute: 'integration-code' } ) accessor integrationCode;

	// The loop fields
	@property( { type: Array, attribute: false } ) accessor fields = [];

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				${ strings.editLoopFilter }

				<uo-button 
					class="filter-item-edit" 
					color="transparent" 
					size="small"
					slot="target"

					@click=${ this.handleEditFilter }
				>
					<uo-icon id="pencil"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}

	/**
	 * Handles the edit functionality
	 */
	handleEditFilter() {
		this.createDialog();
	}

	/**
	 * Creates the dialog with the sentence and fields
	 */
	createDialog() {
		// Create the node that we'll use to render the dialog
		// This node will be added as a direct child of the body node.
		// We can't add it inside the component created on this class because of z-index issues
		const $wrapper = document.createElement( 'div' );
		document.body.append( $wrapper );

		render(
			html`
				<uap-builder-item-loop-filter-edit-dialog
					loop-id=${ this.loopID }
					loop-filter-id=${ this.loopFilterID }
					loop-filter-code=${ this.loopFilterCode }
					integration-code=${ this.integrationCode }
					.fields=${ this.fields }
				></uap-builder-item-loop-filter-edit-dialog>
			`,
			$wrapper
		);
	}
}